import { Form } from "semantic-ui-react";

const AddEditUser = (props) => {
  const { selectedUser, onChangeField } = props;
  return (
    <Form size="large">
      <Form.Input
        required
        id="fullName"
        value={selectedUser.fullName || ""}
        label="Full Name"
        placeholder="Name"
        onChange={onChangeField}
      />
      <Form.Input
        required
        id="email"
        value={selectedUser.email || ""}
        label="Email"
        placeholder="Email"
        onChange={onChangeField}
      />
      <Form.Select
        required
        id="role"
        value={selectedUser.role || ""}
        label="Role"
        placeholder="Select Role"
        options={[
          { text: "Admin", value: "Admin" },
          { text: "CSR", value: "CSR" },
          { text: "Attorney", value: "Attorney" },
        ]}
        onChange={onChangeField}
      />
    </Form>
  );
};
export default AddEditUser;
